export default (...fns) => (...args) =>
  fns.filter(Boolean).forEach(fn => fn(...args))
